<script lang="ts">
    import { fly } from "svelte/transition"
    import { location, login, sidebarOverlay } from "../store"

    import { mdiCloseCircleOutline } from "@mdi/js"
    import Icon from "./Icon.svelte"
    import Overview from "./Overview.svelte"
    import { api } from "../../api"
    import { spaNavigate } from "../actions"
    import { onMount } from "svelte"
    function clickOutside(node: Node, callback: Function) {
        const handleOutsideClick = ({ target }) => {
            if (!node.contains(target)) {
                callback(target)
            }
        }

        typeof window !== "undefined" && window.addEventListener("click", handleOutsideClick, true)

        return {
            destroy() {
                typeof window !== "undefined" && window.removeEventListener("click", handleOutsideClick, true)
            },
        }
    }
    async function postLogout() {
        await api<ServerLogin>(
            "login?logout=true",
            {
                method: "POST",
            },
            {}
        ).then(() => {
            login.set(null)
            $sidebarOverlay = false
            spaNavigate("/login")
        })
    }

    onMount(() => {
        if (typeof window !== "undefined") {
            const body = document.querySelector("body")
            body.style.overflow = "hidden"
            return () => {
                body.style.overflow = "auto"
            }
        }
    })
</script>

<div
    class="sidebaroverlay"
    transition:fly="{{ x: 1000 }}"
    use:clickOutside="{(target) => {
        $sidebarOverlay = false
    }}"
>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a
        class="sidebar_closer"
        href=""
        on:click|preventDefault="{() => {
            $sidebarOverlay = false
        }}"
    >
        <Icon
            path="{mdiCloseCircleOutline}"
            size="24px"
        />
    </a>
    <button
        on:click="{() => {
            $sidebarOverlay = false
            if ($location.path !== '/' && !!$location.path) spaNavigate('/')
        }}"
    >
        <img
            src="../../../assets/icons/solar_home-smile-angle-outline.svg"
            alt="icon"
        />
        <span>Übersicht</span>
    </button>
    <Overview />
    <div class="action-row">
        <button
            class="logout"
            on:click="{postLogout}"
        >
            <img
                src="../../../assets/icons/solar_power-outline.svg"
                alt="icon"
            />
            <span>Logout</span>
        </button>
    </div>
</div>

<style lang="less">
    @import "../../../assets/variables.less";
    .sidebaroverlay {
        position: fixed;
        bottom: 0px;
        left: initial;
        right: 0;
        width: 100vw;
        top: 0px;
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 9999;
        background: var(--yellow-100);
        color: var(--text-000);
        display: flex;
        flex-direction: column;

        @media @desktop {
            width: 80vw;
            border-left: 1px solid var(--text-000);
            overflow-y: auto;
        }
        @media @large_desktop {
            width: 50vw;
        }
        .sidebar_closer {
            background: var(--background);
            color: var(--on-background);
            display: flex;
            align-items: center;
            justify-content: flex-end;
            border-bottom: 1px solid var(--border-color-default);
            padding: 1.2rem 3.6rem 0px 3.6rem;
            @media @mobile {
                padding: 1.2rem 1.2rem 0px 1.2rem;
            }
            margin-bottom: 20px;
            font-size: 18px;
            height: 65px;
        }
        button {
            display: flex;
            gap: 1.2rem;
            align-items: center;
            padding: 0.8rem 3.6rem;
            @media @mobile {
                padding: 0.8rem 1.2rem;
            }
            img {
                width: 1.2rem;
                height: 1.2rem;
            }
            span {
                color: var(--text-000);
                font-size: 1.2rem;
            }
        }
        .action-row {
            display: flex;
            border-top: 2px solid var(--white-100);
            background: var(--text-100);
            justify-content: flex-end;
            margin-top: auto;
            button {
                display: flex;
                gap: 0.5rem;
                align-items: center;
                padding: 0.6rem 1.2rem;
                color: white;
                img {
                    width: 1.2rem;
                    height: 1.2rem;
                }
                span {
                    font-size: 1.2rem;
                    color: white;
                }
            }
        }
    }
</style>
